import { Box } from '@mui/material'
import { useState } from 'react';
import { useEffect } from 'react';
import OfferLetterTemplates from './OfferLetter/OfferLetterTemplates';
import OfferLetterForm from './OfferLetter/OfferLetterForm';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';
import { GetObjectCommand } from '@aws-sdk/client-s3';
import { s3Client } from '../../Base/helper/baseFunctions';
import { useDispatch, useSelector } from "react-redux";
import { GetCompanyLogoHelper } from '../../Ancillary/CompanyDetails/helper/CompanyDetailsHelper';
import { GetLetterHeadAction } from '../../../../store/Ancillary/LetterHead/Action';

const OfferLetterLandingPage = ({ onModeChange }) => {
    const dispatch = useDispatch();
    const [imageUrl, setImageUrl] = useState("");
    const [currentMode, setCurrentMode] = useState("grid");
    const [data, setData] = useState("");
    const { letterHeadData } = useSelector(state => state?.AncillaryReducer?.LetterHeadReducer);

    useEffect(() => {
        if (onModeChange) {
            onModeChange(currentMode !== "grid");
        }
        return () => {
            if (onModeChange) {
                onModeChange(false);
            }
        };
    }, [currentMode, onModeChange]);

    useEffect(() => {
        dispatch(GetLetterHeadAction());
        GetCompanyLogoHelper().then((res) => {
            res?.data?.data?.[0]?.companylogo && getImageSignedUrl(res?.data?.data?.[0]?.companylogo);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getImageSignedUrl = async (currentData) => {
        let filename = currentData;
        const bucketParams = {
            Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
            Key: filename,
        };
        const expiresIn = 604800;
        try {
            const url = await getSignedUrl(
                s3Client,
                new GetObjectCommand(bucketParams),
                { expiresIn }
            ); // Adjustable expiration.
            setImageUrl(url); // This will update the imageUrl state
            return url;
        } catch (err) {
            console.error("Error fetching image URL", err);
        }
    };

    return (
        <>
            {
                <Box sx={{ width: '100%', padding: currentMode === "grid" ? "0px 10px 25px 10px" : "0px 6px 0px 6px" }}>
                    {
                        currentMode === "grid" ? <OfferLetterTemplates setCurrentMode={setCurrentMode} setData={setData} data={data} />
                            : <OfferLetterForm setCurrentMode={setCurrentMode} currentMode={currentMode} setData={setData} data={data} companylogo={imageUrl} 
                            letterHeadData={letterHeadData?.[0]} />
                    }
                </Box>
            }
        </>

    )
}

export default OfferLetterLandingPage